"use strict";

{
	const { Swiper } = await import("../swiper/swiper.js"),
		{ Pagination } = await import("../swiper/pagination.js"),
		{ Autoplay } = await import("../swiper/autoplay.js"),
		{ EffectFade } = await import("../swiper/effect-fade.js"),
		{ Controller } = await import("../swiper/controller.js");

	const instance = new Swiper(".swiper-section-c-contents", {
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		centeredSlides: true,
		controller: {
			control: ".swiper-section-c-images",
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		modules: [Autoplay, Controller, EffectFade, Pagination],
		pagination: {
			clickable: true,
			el: ".swiper-section-c-contents-pagination",
			enabled: true,
		},
		slidesPerView: "auto",
		speed: 1000,
		watchOverflow: true,
		watchSlidesProgress: true,
	});

	if (window.hasOwnProperty("section_c_swipers")) {
		const ancestor = instance.wrapperEl.parentElement.parentElement;
		const entry = window.section_c_swipers.get(ancestor);
		if (entry) {
			entry.contents = instance;
			window.section_c_swipers.set(ancestor, entry);
		} else {
			window.section_c_swipers.set(ancestor, { contents: instance });
		}
	}
}
